import { VMSArrayConstantType } from "@/constants";
import { useConstants } from "./useConstants";

export const useArrayConstants = () => {
  const arrayConstants = useConstants("ARRAY") as VMSArrayConstantType;
  return arrayConstants;
};
